import { render } from "./ShipmentList.vue?vue&type=template&id=559aacbe&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"

import "./ShipmentList.vue?vue&type=style&index=0&id=559aacbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559aacbe"]])

export default __exports__